"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7326],{

/***/ 12910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16606);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(62099);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62009);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jigsaw_puzzle_lib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89232);
/* harmony import */ var react_jigsaw_puzzle_lib_jigsaw_puzzle_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94495);
/* harmony import */ var react_jigsaw_puzzle_lib_jigsaw_puzzle_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_jigsaw_puzzle_lib_jigsaw_puzzle_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74627);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73165);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var components_Feature_ChildCulture_ChildHero__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22885);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38505);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90894);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/no-explicit-any */ 








var PuzzleGame = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
    var ref52 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), activeIndex = ref52[0], setActiveIndex = ref52[1];
    var ref53 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), activePuzzleIndex = ref53[0], setActivePuzzleIndex = ref53[1];
    var ref54 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([
        2,
        2
    ]), difficulty = ref54[0], setDifficulty = ref54[1];
    var ref55 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(-1), selectedDiff = ref55[0], setSelectedDiff = ref55[1];
    var ref56 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), solvedPuzzle = ref56[0], setSolvedPuzzle = ref56[1];
    var numberOfItems = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.Items) === null || ref1 === void 0 ? void 0 : ref1.length;
    var setDiffClicked = function(row, column, selectedDiffArg, index) {
        setActiveIndex(index);
        setSolvedPuzzle(false);
        setActivePuzzleIndex(index);
        setDifficulty([
            row,
            column
        ]);
        setSelectedDiff(selectedDiffArg);
        var element = document.querySelector("#puzzleWrp");
        setTimeout(function() {
            if (element) {
                var top = element.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({
                    top: top,
                    behavior: "smooth"
                });
            }
        }, 600);
    };
    var ref57 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), start = ref57[0], setStart = ref57[1];
    var ref58 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isDragging = ref58[0], setIsDragging = ref58[1];
    var navigationRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var handleTouchStart = function(e) {
        var ref;
        setStart((ref = e === null || e === void 0 ? void 0 : e.touches[0]) === null || ref === void 0 ? void 0 : ref.clientX);
    };
    var handleMouseDown = function(e) {
        setIsDragging(true);
        setStart(e.clientX);
    };
    var handleTouchMove = function(e) {
        if (!navigationRef.current || !e.touches.length) return;
        var currentX = e.touches[0].clientX;
        var diffX = (start || 0) - currentX;
        navigationRef.current.scrollLeft += diffX;
    // setStart(currentX)
    };
    var handleMouseMove = function(e) {
        if (!isDragging || !start || !navigationRef.current) return;
        var currentX = e.clientX;
        var diffX = start - currentX;
        navigationRef.current.scrollLeft += diffX;
    };
    var handleTouchEnd = function() {
        setStart(null);
    };
    var handleMouseUp = function() {
        setIsDragging(false);
        setStart(null);
    };
    var handleMouseLeave = function() {
        setIsDragging(false);
        setStart(null);
    };
    var throttle = function(func, limit) {
        var lastFunc;
        var lastRan;
        return function throttle() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var context = this;
            if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();
            } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(function() {
                    if (Date.now() - lastRan >= limit) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                }, limit - (Date.now() - lastRan));
            }
        };
    };
    var ref59 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isPuzzleDragging = ref59[0], setIsPuzzleDragging = ref59[1];
    var puzzleRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var handleTouchMove = function(event) {
            if (isPuzzleDragging) {
                event.preventDefault();
            }
        };
        var element = puzzleRef === null || puzzleRef === void 0 ? void 0 : puzzleRef.current;
        if (element) {
            // Add the event listener with passive: false
            element.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
        }
        // Cleanup event listener on component unmount
        return function() {
            if (element) {
                element.removeEventListener("touchmove", handleTouchMove);
            }
        };
    }, [
        isPuzzleDragging
    ]);
    var handleDragStart = function() {
        setIsPuzzleDragging(true);
    };
    var handleDragEnd = function() {
        setIsPuzzleDragging(false);
    };
    var handleMouseMoveThrottled = throttle(handleMouseMove, 100);
    var ref60 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), swiperInstence = ref60[0], setSwiperInstence = ref60[1];
    var handlePrevClick = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        swiperInstence.slidePrev();
    }, [
        swiperInstence
    ]);
    var handleNextClick = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        swiperInstence.slideNext();
    }, [
        swiperInstence
    ]);
    var ref61 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), swiperAtEnd = ref61[0], setSwiperAtEnd = ref61[1];
    var ref62 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), swiperAtStart = ref62[0], setSwiperAtStart = ref62[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: " ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "rtl" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pt-10 responsive",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-1 gap-1 relative w-fit max-w-[90vw] overflow-x-auto scrollbar-hide snap-mandatory snap-x scroll-smooth cursor-grab",
                        ref: navigationRef,
                        onTouchStart: handleTouchStart,
                        onTouchMove: handleTouchMove,
                        onMouseMove: handleMouseMoveThrottled,
                        onMouseDown: handleMouseDown,
                        onMouseUp: handleMouseUp,
                        onMouseLeave: handleMouseLeave,
                        onTouchEnd: handleTouchEnd,
                        children: [
                            (props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Navigation) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && (props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Navigation) === null || ref5 === void 0 ? void 0 : ref5.map(function(Link, index) {
                                var ref, ref1, ref2, ref3, ref4;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative group flex  items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavLink, {
                                        targetId: Link === null || Link === void 0 ? void 0 : (ref = Link.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.ButtonUrl) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.anchor,
                                        locale: props === null || props === void 0 ? void 0 : props.locale,
                                        text: Link === null || Link === void 0 ? void 0 : (ref3 = Link.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ButtonText) === null || ref4 === void 0 ? void 0 : ref4.value,
                                        isSelected: (Link === null || Link === void 0 ? void 0 : Link.name) === "Puzzle Game"
                                    })
                                }, index);
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute bottom-0 w-full h-1 left-0 bg-neutral-200 rounded"
                            })
                        ]
                    }),
                    (props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.HeroSlides) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Feature_ChildCulture_ChildHero__WEBPACK_IMPORTED_MODULE_8__["default"], {
                            fields: {
                                HeroImagesList: props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : ref8.HeroSlides
                            }
                        })
                    })
                ]
            }),
            selectedDiff == -1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "",
                children: (props === null || props === void 0 ? void 0 : (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.PreSelectText) === null || ref10 === void 0 ? void 0 : ref10.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col items-center justify-center my-20 lg:my-28",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-lg md:text-xl lg:text-3xl text-brand-50 font-semibold animate-top-dga",
                        children: props === null || props === void 0 ? void 0 : (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.PreSelectText) === null || ref12 === void 0 ? void 0 : ref12.value
                    })
                })
            }),
            solvedPuzzle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: function(e) {
                    if (e.target === e.currentTarget) {
                        setSolvedPuzzle(false);
                        setSelectedDiff(-1);
                        setActivePuzzleIndex(0);
                        setActiveIndex(0);
                        setDifficulty([
                            2,
                            2
                        ]);
                    }
                },
                className: "fixed z-[9999] flex justify-center items-center bg-[#00000055] top-0 left-0 h-screen w-screen",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-white items-start translate-x-[-8px] flex flex-col gap-4 p-4 md:p-6 rounded-2xl shadow-lg w-[350px] max-w-[90%] md:w-[400px] lg:w-[600px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between items-start w-full",
                            children: [
                                (props === null || props === void 0 ? void 0 : (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.SuccessIcon) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.value) === null || ref15 === void 0 ? void 0 : ref15.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative h-[48px] w-[48px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: props === null || props === void 0 ? void 0 : (ref16 = props.fields) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.SuccessIcon) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.value) === null || ref18 === void 0 ? void 0 : ref18.src,
                                        alt: (props === null || props === void 0 ? void 0 : (ref19 = props.fields) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.SuccessIcon) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.value) === null || ref21 === void 0 ? void 0 : ref21.alt) || "Success Icon",
                                        layout: "fill",
                                        objectFit: "contain"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_9__, {
                                    width: 24,
                                    height: 24,
                                    className: "".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "mr-auto" : "ml-auto", "  cursor-pointer"),
                                    onClick: function() {
                                        setSolvedPuzzle(false);
                                        setSelectedDiff(-1);
                                        setActivePuzzleIndex(0);
                                        setActiveIndex(0);
                                        setDifficulty([
                                            2,
                                            2
                                        ]);
                                    }
                                })
                            ]
                        }),
                        (props === null || props === void 0 ? void 0 : (ref22 = props.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.SuccessTitle) === null || ref23 === void 0 ? void 0 : ref23.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-lg font-semibold",
                            children: props === null || props === void 0 ? void 0 : (ref24 = props.fields) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.SuccessTitle) === null || ref25 === void 0 ? void 0 : ref25.value
                        }),
                        (props === null || props === void 0 ? void 0 : (ref26 = props.fields) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.SuccessDescription) === null || ref27 === void 0 ? void 0 : ref27.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                                field: props === null || props === void 0 ? void 0 : (ref28 = props.fields) === null || ref28 === void 0 ? void 0 : ref28.SuccessDescription
                            })
                        }),
                        (props === null || props === void 0 ? void 0 : (ref29 = props.fields) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.SuccessButtonText) === null || ref30 === void 0 ? void 0 : ref30.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "w-full md:w-fit ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "mr-auto" : "ml-auto", " p-2 px-3 bg-primary-600 text-white rounded hover:bg-primary-700"),
                            onClick: function() {
                                setSolvedPuzzle(false);
                                setSelectedDiff(-1);
                                setActivePuzzleIndex(0);
                                setActiveIndex(0);
                                setDifficulty([
                                    2,
                                    2
                                ]);
                            },
                            children: props === null || props === void 0 ? void 0 : (ref31 = props.fields) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.SuccessButtonText) === null || ref32 === void 0 ? void 0 : ref32.value
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "puzzleWrp"
            }),
            selectedDiff != -1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative w-[90%] md:w-[70%] lg:w-[50%] mx-auto my-10 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-0 w-full h-full grid",
                        style: {
                            gridTemplateRows: "repeat(".concat(difficulty[0], ", minmax(0, 1fr))"),
                            gridTemplateColumns: "repeat(".concat(difficulty[1], ", minmax(0, 1fr))")
                        },
                        children: function() {
                            var elements = [];
                            for(var i = 0; i < difficulty[0]; i++){
                                for(var j = 0; j < difficulty[1]; j++){
                                    elements.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "border-[1px] border-primary-1000 w-full h-full"
                                    }, "".concat(i, "-").concat(j)));
                                }
                            }
                            return elements;
                        }()
                    }),
                    difficulty && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative",
                        onTouchStart: handleDragStart,
                        onTouchEnd: handleDragEnd,
                        ref: puzzleRef,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jigsaw_puzzle_lib__WEBPACK_IMPORTED_MODULE_4__/* .JigsawPuzzle */ .v, {
                            imageSrc: (ref34 = props === null || props === void 0 ? void 0 : (ref33 = props.fields) === null || ref33 === void 0 ? void 0 : ref33.Items[activePuzzleIndex].fields) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.ThumnailImage) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.value) === null || ref36 === void 0 ? void 0 : ref36.src,
                            rows: difficulty[0],
                            columns: difficulty[1],
                            onSolved: function() {
                                setSolvedPuzzle(true);
                                var element = document.querySelector("#puzzleWrp");
                                if (element) {
                                    var top = element.getBoundingClientRect().top + window.pageYOffset - 100;
                                    window.scrollTo({
                                        top: top,
                                        behavior: "smooth"
                                    });
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " flex flex-col gap-8",
                children: [
                    ((props === null || props === void 0 ? void 0 : (ref37 = props.fields) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.Title) === null || ref38 === void 0 ? void 0 : ref38.value) || (props === null || props === void 0 ? void 0 : (ref39 = props.fields) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.Description) === null || ref40 === void 0 ? void 0 : ref40.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex responsive flex-col gap-8",
                        children: [
                            (props === null || props === void 0 ? void 0 : (ref41 = props.fields) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.Title) === null || ref42 === void 0 ? void 0 : ref42.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-[20px] md:text-2xl font-bold text-brand-[#00293A]",
                                children: props === null || props === void 0 ? void 0 : (ref43 = props.fields) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.Title) === null || ref44 === void 0 ? void 0 : ref44.value
                            }),
                            (props === null || props === void 0 ? void 0 : (ref45 = props.fields) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.Description) === null || ref46 === void 0 ? void 0 : ref46.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-4 font-semibold text-[#00293A]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_10__/* .RichText */ .H, {
                                        field: props === null || props === void 0 ? void 0 : (ref47 = props.fields) === null || ref47 === void 0 ? void 0 : ref47.Description
                                    })
                                })
                            })
                        ]
                    }),
                    numberOfItems && numberOfItems > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(swiperInstence ? "opacity-100" : "opacity-0", " transition-opacity duration-500  relative py-8 w-full ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "pr-[5%]" : "pl-[5%]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                // ref={puzzleGameItemsSwiperRef}
                                onInit: function(ev) {
                                    setSwiperInstence(ev);
                                },
                                slidesPerView: 1.5,
                                spaceBetween: 16,
                                className: "!p-[1px] !overflow-visible",
                                onSlideChange: function(e) {
                                    e.isEnd ? setSwiperAtEnd(true) : setSwiperAtEnd(false);
                                    e.isBeginning ? setSwiperAtStart(true) : setSwiperAtStart(false);
                                },
                                breakpoints: {
                                    768: {
                                        slidesPerView: 2.2
                                    },
                                    1024: {
                                        slidesPerView: 3.2
                                    },
                                    1280: {
                                        slidesPerView: 4.2
                                    }
                                },
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl,
                                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .A11y */ .s5
                                ],
                                pagination: {
                                    clickable: true,
                                    el: "#puzzle-game-swiper-pagination-bullets"
                                },
                                a11y: {
                                    enabled: true,
                                    paginationBulletMessage: "Go to slide {{index}}"
                                },
                                children: Array.from({
                                    length: numberOfItems
                                }).map(function(_item, index) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
                                    var levelsBtnStyle = "p-2  py-1 flex-1 text-base font-normal  cursor-pointer";
                                    var ref24;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                        onClick: function() {
                                            swiperInstence === null || swiperInstence === void 0 ? void 0 : swiperInstence.slideTo(index);
                                        },
                                        className: "!h-auto overflow-hidden",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "bg-white animate-top-dga group w-full p-4 rounded-2xl flex   ".concat(index == activeIndex ? "border-primary-600 border-[3px] -translate-y-[24px]" : "border border-neutral-300 hover:-translate-y-[24px] ", " flex-col gap-6 transition-transform duration-300 ease-in-out"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "relative h-[160px] rounded-lg md:h-[250px] w-full ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                        src: ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : ref.Items[index].fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ThumnailImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.value) === null || ref3 === void 0 ? void 0 : ref3.src) ? (ref5 = props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : ref4.Items[index].fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.ThumnailImage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.value) === null || ref7 === void 0 ? void 0 : ref7.src : "/event-placeholder.jpg",
                                                        alt: ((ref24 = (ref9 = props === null || props === void 0 ? void 0 : (ref8 = props.fields) === null || ref8 === void 0 ? void 0 : ref8.Items[index].fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.ThumnailImage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.value) === null || ref11 === void 0 ? void 0 : ref11.alt) !== null && ref24 !== void 0 ? ref24 : "").trim() || "Puzzle thumbnail",
                                                        layout: "fill",
                                                        objectFit: "cover",
                                                        className: "rounded-lg object-cover"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col gap-6",
                                                    children: [
                                                        ((ref13 = props === null || props === void 0 ? void 0 : (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : ref12.Items[index].fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Title) === null || ref14 === void 0 ? void 0 : ref14.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            className: "text-lg font-bold ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "text-right" : "text-left", " "),
                                                            children: (ref16 = props === null || props === void 0 ? void 0 : (ref15 = props.fields) === null || ref15 === void 0 ? void 0 : ref15.Items[index].fields) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.Title) === null || ref17 === void 0 ? void 0 : ref17.value
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "opacity-0 group-hover:opacity-100 ".concat(index == activeIndex ? "!opacity-100" : "", "  transition-opacity duration-500 "),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: " hidden w-full group-hover:flex group-hover:opacity-100 opacity-0 transition-opacity duration-300 ".concat(index == activeIndex ? "!flex !opacity-100" : "", " "),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat(levelsBtnStyle, " w-full ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "rounded-tr rounded-br" : "rounded-tl rounded-bl", "\n                               ").concat(selectedDiff == 0 && index == activeIndex ? "bg-primary-600 text-white" : "text-primary-1000 bg-neutral-100 hover:bg-neutral-200", "\n\n                              "),
                                                                        onClick: function() {
                                                                            setSelectedDiff(-1);
                                                                            setTimeout(function() {
                                                                                var ref, ref1, ref2, ref3;
                                                                                setDiffClicked(props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.EasyRowNumber) === null || ref1 === void 0 ? void 0 : ref1.value, props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.EasyColumnNumber) === null || ref3 === void 0 ? void 0 : ref3.value, 0, index);
                                                                            }, 50);
                                                                        },
                                                                        children: props === null || props === void 0 ? void 0 : (ref18 = props.fields) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.EasyText) === null || ref19 === void 0 ? void 0 : ref19.value
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat(levelsBtnStyle, "   ").concat(selectedDiff == 1 && index == activeIndex ? "bg-primary-600  text-white" : "text-primary-1000 bg-neutral-100 hover:bg-neutral-200"),
                                                                        onClick: function() {
                                                                            setSelectedDiff(-1);
                                                                            setTimeout(function() {
                                                                                var ref, ref1, ref2, ref3;
                                                                                setDiffClicked(props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.MediumRowNumber) === null || ref1 === void 0 ? void 0 : ref1.value, props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.MediumColumnNumber) === null || ref3 === void 0 ? void 0 : ref3.value, 1, index);
                                                                            }, 50);
                                                                        },
                                                                        children: props === null || props === void 0 ? void 0 : (ref20 = props.fields) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.MediumText) === null || ref21 === void 0 ? void 0 : ref21.value
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "".concat(levelsBtnStyle, " ").concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "rounded-tl rounded-bl" : "rounded-tr rounded-br", "\n                               ").concat(selectedDiff == 2 && index == activeIndex ? "bg-primary-600 text-white" : "text-primary-1000 bg-neutral-100 hover:bg-neutral-200", "\n\n\n                              "),
                                                                        onClick: function() {
                                                                            setSelectedDiff(-1);
                                                                            setTimeout(function() {
                                                                                var ref, ref1, ref2, ref3;
                                                                                setDiffClicked(props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.HardRowNumber) === null || ref1 === void 0 ? void 0 : ref1.value, props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.HardColumnNumber) === null || ref3 === void 0 ? void 0 : ref3.value, 2, index);
                                                                            }, 50);
                                                                        },
                                                                        children: props === null || props === void 0 ? void 0 : (ref22 = props.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.HardText) === null || ref23 === void 0 ? void 0 : ref23.value
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "\n              relative hidden justify-end ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "pl-[5%]" : "pr-[5%]", " gap-4\n              ").concat(numberOfItems > 1 ? "flex" : "", "\n              ").concat(numberOfItems > 2 ? "md:flex" : "md:hidden", "\n              ").concat(numberOfItems > 3 ? "lg:flex" : "lg:hidden", "\n            "),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_11__.DGACarouselArrow, {
                                        style: "primary",
                                        size: "large",
                                        disabled: swiperAtStart,
                                        direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "right" : "left",
                                        onClick: handlePrevClick
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_carousel_arrow_DGACarouselArrow__WEBPACK_IMPORTED_MODULE_11__.DGACarouselArrow, {
                                        style: "primary",
                                        size: "large",
                                        disabled: swiperAtEnd,
                                        direction: (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() ? "left" : "right",
                                        onClick: handleNextClick
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "puzzle-game-swiper-pagination-bullets",
                                className: "custom_swiper mx-auto md:mx-0 absolute left-0 right-0 md:!hidden !bottom-[0px] !justify-center"
                            })
                        ]
                    }),
                    !numberOfItems || numberOfItems === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: (props === null || props === void 0 ? void 0 : (ref48 = props.fields) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.EmptyItemsText) === null || ref49 === void 0 ? void 0 : ref49.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-center text-lg font-bold py-10",
                            children: props === null || props === void 0 ? void 0 : (ref50 = props.fields) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.EmptyItemsText) === null || ref51 === void 0 ? void 0 : ref51.value
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_12__/* .withDatasourceCheck */ .C)()(PuzzleGame));






var NavLink = function(param) {
    var targetId = param.targetId, locale = param.locale, text = param.text, isSelected = param.isSelected;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_14__.useRouter)();
    var extractInternalPath = function(url) {
        var path = url.split(/.com\//)[1];
        if (path) return ("https://c-main.takamulstg.com" || 0).replace(/\/$/, "") + "/" + locale + "/" + (path || "").replace(/^\/+/, "");
        else {
            return url;
        }
    };
    var href = function(href) {
        var res = extractInternalPath(href);
        return res.slice(0, res.length - 11);
    };
    var HEADER_HEIGHT = 75;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (href(router.asPath)) {
            var element = document.getElementById(targetId);
            if (element) {
                targetId == "culturalEvents" ? window.scrollTo({
                    top: element.offsetTop,
                    behavior: "smooth"
                }) : window.scrollTo({
                    top: element.offsetTop + HEADER_HEIGHT,
                    behavior: "smooth"
                });
            }
        }
    }, [
        router.asPath,
        targetId
    ]);
    var isCurrentPage = router.asPath.includes(targetId) || isSelected;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative z-[3] animate-top-dga",
        children: [
            targetId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                href: "".concat(href(router.asPath), "#").concat(targetId),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "!block text-base font-bold p-4 hover:bg-neutral-100 rounded",
                    children: text
                })
            }),
            !targetId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "!block text-base font-bold p-4 hover:bg-neutral-100 rounded",
                children: text
            }),
            isCurrentPage || isSelected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute w-full bottom-[-0px] left-0 h-[4px] bg-primary-600 rounded"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
        ]
    });
};


/***/ }),

/***/ 45713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73392);
/* harmony import */ var _sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93417);
/* harmony import */ var _sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23317);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62009);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_phone_number_input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20422);
/* harmony import */ var src_context_AuthProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19480);









var DynamicForm = function(param) {
    var fields = param.fields, router = param.router;
    var ref = (0,src_context_AuthProvider__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(), setMessage = ref.setMessage, setIsOpen = ref.setIsOpen;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), actualDate = ref1[0], setActualDate = ref1[1];
    var lang = router.locale;
    // const clearForm = () =>{
    //   const form:any = document.getElementById("myForm");
    //   const invalidElements = document.querySelectorAll(".invalid");
    //   if (form) {
    //     const inputs = form.querySelectorAll("input, textarea, select");  
    //     inputs.forEach((input:any) => {
    //       input.value = "";
    //     });
    //     if(invalidElements.length > 0){
    //       // Remove each invalid element
    //       invalidElements.forEach((element:HTMLElement,index:number) => {
    //         if(index != 0){
    //           if (element && element.classList.length === 1 && element.classList.contains("invalid")) {
    //             element.remove()
    //           }
    //         }
    //       });
    //     }
    //   }
    // }
    // useEffect(()=>{
    //   clearForm()
    // }, [lang])
    var defaultFieldFactory = (0,_sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_5__/* .createDefaultFieldFactory */ .a)();
    defaultFieldFactory.setComponent(_sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_6__/* .FieldTypes.Telephone */ .U.Telephone, function(props) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var tempProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            contactus: false
        });
        var handlePhoneChange = function(value) {
            var newValue = value;
            var valid = true;
            var errorMessages = [];
            if ((props === null || props === void 0 ? void 0 : props.field.model.required) && !newValue) {
                valid = false;
                errorMessages.push("");
            }
            props.onChange(props === null || props === void 0 ? void 0 : props.field.valueField.name, value, valid, errorMessages);
        };
        var handlePhoneBlur = function(e) {
            var ref;
            props === null || props === void 0 ? void 0 : props.tracker.onBlurField(props === null || props === void 0 ? void 0 : props.field, e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value, props === null || props === void 0 ? void 0 : props.errors);
        };
        var onFocus = function(e) {
            props === null || props === void 0 ? void 0 : props.tracker.onFocusField(props === null || props === void 0 ? void 0 : props.field, e.target.value);
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    className: "".concat(tempProps === null || tempProps === void 0 ? void 0 : (ref = tempProps.field) === null || ref === void 0 ? void 0 : (ref1 = ref.model) === null || ref1 === void 0 ? void 0 : ref1.labelCssClass),
                    children: tempProps === null || tempProps === void 0 ? void 0 : (ref2 = tempProps.field) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.model) === null || ref3 === void 0 ? void 0 : ref3.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_phone_number_input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    international: false,
                    defaultCountry: "SA",
                    className: "py-0 px-6 w-full input-theme-color1 text-start ".concat(tempProps === null || tempProps === void 0 ? void 0 : (ref4 = tempProps.field) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.model) === null || ref5 === void 0 ? void 0 : ref5.cssClass),
                    name: tempProps === null || tempProps === void 0 ? void 0 : (ref6 = tempProps.field) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.model) === null || ref7 === void 0 ? void 0 : ref7.name,
                    value: props.value,
                    onChange: handlePhoneChange,
                    onBlur: handlePhoneBlur,
                    onFocus: onFocus,
                    placeholder: tempProps === null || tempProps === void 0 ? void 0 : (ref8 = tempProps.field) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.model) === null || ref9 === void 0 ? void 0 : ref9.placeholderText
                }),
                (props === null || props === void 0 ? void 0 : props.errors) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "invalid",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: props === null || props === void 0 ? void 0 : props.errors
                    })
                })
            ]
        });
    });
    defaultFieldFactory.setComponent(_sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_6__/* .FieldTypes.DateField */ .U.DateField, function(props) {
        var ref, ref1, ref2, ref3;
        var tempProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            contactus: false
        });
        var handleDateChange = function(value) {
            var ref;
            var newValue = value === null || value === void 0 ? void 0 : (ref = value.target) === null || ref === void 0 ? void 0 : ref.value;
            var valid = true;
            var errorMessages = [];
            if (lang == "ar") {
                var ref1;
                var formatter = new Intl.DateTimeFormat("en-GB-u-ca-islamic", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    calendar: "islamic",
                    numberingSystem: "latn"
                });
                var hijriDate = formatter.format(new Date(value === null || value === void 0 ? void 0 : (ref1 = value.target) === null || ref1 === void 0 ? void 0 : ref1.value));
                newValue = hijriDate.split(" ")[0];
            }
            setActualDate(newValue);
            if ((props === null || props === void 0 ? void 0 : props.field.model.required) && !newValue) {
                valid = false;
                errorMessages.push("");
            }
            props.onChange(props === null || props === void 0 ? void 0 : props.field.valueField.name, newValue, valid, errorMessages);
        };
        var handleDateBlur = function(e) {
            var ref;
            props === null || props === void 0 ? void 0 : props.tracker.onBlurField(props === null || props === void 0 ? void 0 : props.field, e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value, props === null || props === void 0 ? void 0 : props.errors);
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    className: "".concat(tempProps === null || tempProps === void 0 ? void 0 : (ref = tempProps.field) === null || ref === void 0 ? void 0 : (ref1 = ref.model) === null || ref1 === void 0 ? void 0 : ref1.labelCssClass),
                    children: tempProps === null || tempProps === void 0 ? void 0 : (ref2 = tempProps.field) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.model) === null || ref3 === void 0 ? void 0 : ref3.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "date",
                            value: props === null || props === void 0 ? void 0 : props.value,
                            onChange: handleDateChange,
                            onBlur: handleDateBlur
                        }),
                        (0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_1__["default"])() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute top-[1.7rem] right-[2.9rem] w-1/2 bg-[#f2f2f2] z-30",
                            children: actualDate
                        })
                    ]
                }),
                (props === null || props === void 0 ? void 0 : props.errors) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "invalid",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: props === null || props === void 0 ? void 0 : props.errors
                    })
                })
            ]
        });
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "myForm",
        className: "py-40 dynamic-form [&>.form-errors]:hidden ".concat(lang === "ar" ? "rtl" : "ltr"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_react_forms__WEBPACK_IMPORTED_MODULE_10__/* .Form */ .l, {
            // language={router.locale}
            form: fields,
            sitecoreApiHost: "",
            sitecoreApiKey: "{9F8E829B-830F-4075-8383-18B42FEB7758}" || 0,
            fieldFactory: defaultFieldFactory,
            onRedirect: function(_) {
                setIsOpen(true);
                // clearForm()
                setMessage({
                    code: 200,
                    message: lang == "ar" ? "تم الإرسال" : "Form submitted successfully"
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_2__.withRouter)(DynamicForm));


/***/ })

}]);